import { connect } from "react-redux";
import App, { AppProps as _AppProps } from "./App-container";
import { AppState } from "../../redux/store/AppState";
import {
  PickReduxDispatchProps,
  PickReduxStateProps,
} from "../../util/typeUtil";
import InProgressUtils from "../../redux/util/inProgressUtils";
import { ActionSender } from "../../model/ActionSender";
import AuthenticationUtils from "../../redux/util/authenticationUtils";
import ErrorUtils from "../../redux/util/errorUtils";
import {AppReduxProps} from "./App-view";

// Own props, i.e. props that this component takes as input
interface AppProps extends Omit<_AppProps, keyof AppReduxProps> {
}

// Input props provided to the wrapped component by this connect component, using mapStateToProps
type ReduxStateProps = PickReduxStateProps<_AppProps, AppProps>;
// Dispatch props provided to the wrapped component by this connect component
type ReduxDispatchProps = PickReduxDispatchProps<_AppProps, AppProps>;

const sender: ActionSender = { key: "index" };

function mapStateToProps(state: AppState, props: AppProps): ReduxStateProps {
  return {
    isReady: InProgressUtils.selectNotInProgress(sender.key, state),
    auth: AuthenticationUtils.selectAuthentication(state),
    errors: ErrorUtils.selectErrors(state),
    logoutCompleted: AuthenticationUtils.selectLogoutCompleted(state),
  };
}

function areStatesEqual(next: AppState, prev: AppState): boolean {
  return (
      InProgressUtils.compareInProgressStates(next, prev) &&
      AuthenticationUtils.compareAuthenticationStates(next, prev) &&
      ErrorUtils.compareErrorStates(next, prev)
  );
}

export default connect<ReduxStateProps, ReduxDispatchProps, AppProps, AppState>(
    mapStateToProps,
    {},
    null,
    {
      areStatesEqual,
    }
)(App);
